import { render } from "./PCTransfer.vue?vue&type=template&id=074019c8"
import script from "./PCTransfer.vue?vue&type=script&lang=js"
export * from "./PCTransfer.vue?vue&type=script&lang=js"

import "./PCTransfer.vue?vue&type=style&index=0&id=074019c8&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__